import React, { ReactNode } from "react";
import { FunnelChartState } from "@/components/Funnel/types";
import { type CommunityStatusSelectOption } from "@/components/FunnelsChart";
import { Card, CardContent } from "@/components/ui";
import { ChartHeader } from "@/components/ChartHeader";
import { Funnel } from "@/components/FunnelsChart";
import { format } from "date-fns";
import { cn } from "@/lib/utils";

export const DATE_FORMAT = "MMM dd, yyyy";

interface Props {
  title: string;
  date: Date;
  compareDate: Date | undefined;
  menuOptions?: {
    label: string;
    onClick?: () => void;
    icon?: ReactNode;
    disabled?: boolean;
  }[];
  subtitle: string;
  children: React.ReactNode;
  showRiseIcon?: boolean;
  onBarClick?: (
    stage: FunnelChartState | null,
    communityStatus: CommunityStatusSelectOption | null,
    funnel: Funnel | null,
  ) => void;
}

export const FunnelChartWrapper: React.FC<Props> = ({
  title,
  subtitle,
  menuOptions,
  date,
  compareDate,
  onBarClick,
  children,
  showRiseIcon,
}) => {
  return (
    <Card>
      <ChartHeader
        {...{
          title,
          subtitle,
          menuOptions,
          showRiseIcon,
        }}
      />
      <CardContent
        className="overflow-x-hidden pt-2"
        onClick={() => onBarClick && onBarClick(null, null, null)}
      >
        {children}
        <div className="mt-2 flex gap-8 text-xs text-muted-foreground">
          <DateLegend
            classNameLeft="bg-funnel-1-left"
            classNameRight="bg-funnel-1-right"
            date={date}
          />
          {compareDate && (
            <DateLegend
              classNameLeft="bg-funnel-2-left"
              classNameRight="bg-funnel-2-right"
              date={compareDate}
            />
          )}
        </div>
      </CardContent>
    </Card>
  );
};

const DateLegend = ({
  date,
  classNameLeft,
  classNameRight,
}: {
  date: Date;
  classNameLeft: string;
  classNameRight: string;
}) => {
  const dateFormat = "MMMM d, yyyy";
  return (
    <div className="flex items-center gap-1">
      <div className="flex gap-[1px]">
        <div className={cn("h-3 w-8 rounded-s-[4px]", classNameLeft)}></div>
        <div className={cn("h-3 w-8 rounded-e-[4px]", classNameRight)}></div>
      </div>
      {format(date, dateFormat)}
    </div>
  );
};
